import { defineMessages } from 'react-intl'

export const subscriptionInfoMessages = defineMessages({
  renewalDate: {
    id: 'subscriptionInfo.renewalDate',
    description: 'Renewal date of subscription',
    defaultMessage: 'Renewal Date{br}{date}',
  },
  resubscribe: {
    id: 'subscriptionInfo.resubscribe',
    description:
      'Text for CTA to subscribe again to the subscription (required not to be Resubscribe)',
    defaultMessage: 'Subscribe',
  },
  upgrade: {
    id: 'subscriptionInfo.upgrade',
    description: 'CTA button text to upgrade current subscription',
    defaultMessage: 'Subscribe',
  },
  manage: {
    id: 'subscriptionInfo.manage',
    description: 'Manage current subscription',
    defaultMessage: 'Manage',
  },
  subscriptionStatus: {
    id: 'subscriptionInfo.subscriptionStatus',
    description: 'A caption of Subscription Status block',
    defaultMessage: 'Subscription Status',
  },
  subscriptionExpiry: {
    id: 'subscriptionInfo.subscriptionExpiry',
    description: 'Subscripition expiration date',
    defaultMessage: 'Expiration Date{br}{endDate}',
  },
  subscriptionUpgrade: {
    id: 'subscriptionInfo.subscriptionUpgrade',
    description: 'A placeholder shown when no Stripe subscription is purchased',
    defaultMessage: 'Subscribe to Savant Essentials',
  },
  essentialPlanName: {
    id: 'subscriptionInfo.essentialPlanName',
    description: 'A user friendly name for Essentials subscription plan',
    defaultMessage: 'Savant Essentials',
  },
  networkPlanName: {
    id: 'subscriptionInfo.networkPlanName',
    description: 'A user friendly name for Smart Network subscription plan',
    defaultMessage: 'Smart Network',
  },
  enrolledPlan: {
    id: 'subscriptionInfo.enrolledPlan',
    description: 'A placeholder for enrolled subscription plan',
    defaultMessage: '{planName} Active',
  },
  nonRenewalPlan: {
    id: 'subscriptionInfo.nonRenewalPlan',
    description:
      'A placeholder for a plan which is not going to be renewed (is canceled) but is not expiring',
    defaultMessage: '{planName} Active',
  },
  expiringPlan: {
    id: 'subscriptionInfo.expiringPlan',
    description: 'A placeholder for active but expiring subscription plan',
    defaultMessage: '{planName} Expiring Soon',
  },
  moreDetails: {
    id: 'subscriptionInfo.moreDetails',
    description: 'Link text leading to "Subscription Details" page',
    defaultMessage: 'More Details',
  },
  cancelSubscription: {
    id: 'subscriptionInfo.cancelSubscription',
    description: 'Button text for cancelling subscription',
    defaultMessage: 'Cancel Auto Renewal',
  },
  cancelRenewal: {
    id: 'subscriptionInfo.cancelRenewal',
    description: 'Button text for cancelling subscription',
    defaultMessage: 'Cancel Renewal',
  },
  noPurchasePermission: {
    id: 'subscriptionInfo.noPurchasePermission',
    description:
      'A caption shown in tooltip notifying there is no permissions to manage subscriptions',
    defaultMessage:
      'Your account does not have Purchasing enabled for SCM.  Your account manager can enable this on your contacts page in the Savant Community by enabling the purchasing option under Savant Central Management.',
  },
  noValidVersion: {
    id: 'subscriptionInfo.noValidVersion',
    description:
      'A caption shown in tooltip notifying the version is out of date',
    defaultMessage:
      'Subscriptions are only supported on SavantOS 10.0 and later.',
  },
})
